import { Injectable } from '@angular/core';
import { combineLatest, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ApiService } from '../api-service';
import { ListResponse } from '../models/request-response';
import {
    Mk2Request,
    Mk2Response,
    ProtoRequest,
    ProtoResponse
} from '../models/request-response-all-java';
import { LsqDataSource } from './lsq-data-source';

@Injectable({ providedIn: 'root' })
export class LsqApiServiceDataSource<
    ResponseType extends ProtoResponse | ListResponse<any> | Mk2Response,
    RequestType extends Request | void | ProtoRequest | Mk2Request
> extends LsqDataSource<ResponseType> {
    public request: RequestType;

    constructor(
        private _apiService: ApiService<RequestType, ResponseType>,
        initialRequest?: RequestType
    ) {
        super({
            data$: _apiService.dataStream.pipe(shareReplay(1)),
            loading$: _apiService.isInFlightStream.pipe(shareReplay(1)),
            error$: _apiService.errorStream.pipe(shareReplay(1)),
            noData$: combineLatest([_apiService.dataStream, _apiService.isInFlightStream]).pipe(
                map(([{ rows }, isInFlight]): boolean => !isInFlight && (!rows || !rows.length)),
                shareReplay(1)
            )
        });

        if (initialRequest) {
            this.dispatchRequest(initialRequest);
        }
    }

    public dispatchRequest(newRequest: Partial<RequestType> = {}): void {
        if (!this.request) {
            this.request = newRequest as RequestType;
        }
        this._updateRequest(newRequest);
        // TODO: The fact that this has no `replay` but doesn't break anything suggests that it's
        // maybe not being used. Explore deprecating `ApiService#requestStream` altogether.
        this._apiService.setRequestStream(of(this.request));
        this._apiService.execute(this.request);
    }

    private _updateRequest(requestUpdate: Partial<RequestType>): void {
        this.request = {
            ...this.request,
            ...requestUpdate
        };
    }
}
